import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[htcViewContainerDirective]',
  standalone: false,
})
export class ViewContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
